import { get } from '../utils/axios'

export const getRecruitsDetailsAPI = async (param) => {
  // const body = { aeNo }
  return await get('recruits/details', param)
}

export const getWorkTypeFileAPI = async (body) => {
  return await get('works/file', body)
}

export const RecruitsAeAPI = async (param) => {
  return await get('recruits/ae', param)
}

export const RecruitsAEpersonalEducationAPI = async (param) => {
  return await get('recruits/details/educations', param)
}

export const RecruitsAEpersonalWorkAPI = async (param) => {
  return await get('recruits/details/works', param)
}

export const RecruitsEducationsAPI = async (param) => {
  return await get('recruits/details/educations', param)
}

export const RecruitsWorksAPI = async (param) => {
  return await get('recruits/details/works', param)
}

export const RecruitsAePersonalAPI = async (param) => {
  return await get('recruits/ae/id', param)
}
